import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiComingSoonBackSoonRequestBody, ApiEmptyResponse } from './api-coming-soon-back-soon.models';

import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

@Injectable()

/**
 * Servicio para la suscripción en la Newsletter en la API
 */
export class ApiComingSoonBackSoonService {
    constructor(private readonly http: HttpClient, private readonly requestService: HttpRequestsService) {}

    public subscribeComingSoonBackSoon(
        storeId: string,
        languageId: string,
        body: ApiComingSoonBackSoonRequestBody,
        catalogId?: string,
        categoryId?: string,
        productId?: string
    ): Observable<ApiEmptyResponse> {
        const slug = `catalog/store/${storeId}/${catalogId}/category/${categoryId}/product/${productId}/stocknotification`;
        const url = this.requestService.requestUrl(slug, languageId, null, false, '2');
        return this.http.post<ApiEmptyResponse>(url, body);
    }
}
